module.exports = __webpack_public_path__ + "assets/img/sy-11.0b52d458.png";